export const __DEV__ = import.meta.env.DEV;

export const BASE_API_ROUTE = import.meta.env.VITE_BASE_API_ROUTE;
export const API_V1 = `${BASE_API_ROUTE}/api/v1`;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
